import { Component, Host, h, Prop, Element, Event, type EventEmitter } from '@stencil/core'
import { type CobaltIcon } from '../../../cobalt-icon/cobalt-icon'

export interface ActionItemType {
  label: string
  disabled?: boolean
}

@Component({
  tag: 'cobalt-dropdown-action-item'
})
export class CobaltDropdownActionItem {
  /**
   * label of the item
   */
  @Prop({ mutable: true }) label!: string
  /**
   * A boolean indicating the disable state of the action item. The `aria-disabled` attribute relies on this property.
   */
  @Prop({ mutable: true }) iconName?: CobaltIcon['name']
  @Prop({ mutable: true }) description?: string
  @Prop({ mutable: true }) disabled?: boolean

  @Element() element: HTMLElement

  /**
   * Emitted when the item is clicked.
   */
  @Event() cobaltDropdownActionItemClick: EventEmitter

  render(): any {
    return (
      <Host>
        <core-dropdown-action-item
          label={this.label}
          iconName={this.iconName}
          description={this.description}
          disabled={this.disabled}
          onCoreDropdownActionItemClick={event => {
            this.cobaltDropdownActionItemClick.emit(event)
          }}
        ></core-dropdown-action-item>
      </Host>
    )
  }
}
